import axios from "axios";
import { KeycloakClientFactory } from "./keycloak/factory";

declare const genv: any;

const api = axios.create({
  baseURL: genv.GARUDA_API_URL,
  headers: {
    "Content-type": "application/json",
  },
});

api.interceptors.request.use(
  (config: any) => {
    const keycloakClient = KeycloakClientFactory.getInstance();
    const token = `Bearer ${keycloakClient.getAccessToken()}`;
    config.headers.Authorization = token;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
